import { AppState } from '@store/state';
import { CartState } from '@store/cart';
import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { PosQuote } from '../../../models';
import { Store as AppStore } from '@ngrx/store';

@Component({
  selector: 'app-cart-total-display',
  templateUrl: './cart-total-display.component.html',
  styleUrls: ['./cart-total-display.component.scss'],
})
export class CartTotalDisplayComponent implements OnInit {

  constructor(
      public store: AppStore<AppState>,
  ) { }

  ngOnInit() {}

  get cartState(): Observable<CartState> {
    return this.store.select(state => state.cartState);
  }

  get quote(): Observable<PosQuote> {
    return this.store.select(state => state.cartState.quote);
  }

}
